import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { useAuth } from "./hooks/useAuth";
import { CurrencyProvider } from "./context/CurrencyContext";
import AppRoutes from "./routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AppContent: React.FC = () => {
  const { fetchCurrentUser, token } = useAuth();

  useEffect(() => {
    // Check if user is logged in on app start
    if (token) {
      fetchCurrentUser();
    }
  }, [token, fetchCurrentUser]);

  return <AppRoutes />;
};

function App() {
  return (
    <Provider store={store}>
      <ToastContainer />
      <CurrencyProvider>
        <Router>
          <div className="App">
            <AppContent />
          </div>
        </Router>
      </CurrencyProvider>
    </Provider>
  );
}

export default App;
